import "./edit-tenant.scss";

import { LocalRole } from "@core/model/local-role.enum";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";

import FormTenant from "../form-tenant/form-tenant";
import { useEditTenant } from "./edit-tenant.hook";

export function EditTenant() {
  const { getUserRole } = useUserIdentityContext();
  const userRole = getUserRole();
  const isAdmin = userRole.name.toUpperCase() === LocalRole.Admin;

  const {
    tenantData,
    isLoading,
    tenantError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditTenant();

  const title = tenantData?.business_name ? (
    <h1>{tenantData?.business_name}</h1>
  ) : (
    <h1>Edit Tenant</h1>
  );
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <FormTenant />
    </div>
  );

  return (
    <div id="EditTenant" className="tenant">
      <HeaderContent
        title={title}
        backIcon={isAdmin ? <FaChevronLeft /> : undefined}
        onBack={isAdmin ? () => handleBack() : undefined}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {tenantError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditTenant;
